import { useEffect } from "react";
import "./App.css";
import RouteComponent from "./routes/Route";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SessionExpiredModal from "src/components/session-expired/SessionExpiredModal";

function App() {

    useEffect(() => {
    // Disable right click
    const handleContextMenu = (e) => {
      e.preventDefault();
    };

    // Disable keyboard shortcuts
    const handleKeyDown = (e) => {
      const key = e.key.toUpperCase();

      // F12
      if (e.key === "F12") {
        e.preventDefault();
        return;
      }

      // Ctrl + Shift + I/J/C
      // if (
      //   e.ctrlKey &&
      //   e.shiftKey &&
      //   ["I", "J", "C"].includes(key)
      // ) {
      //   e.preventDefault();
      //   return;
      // }

      // Ctrl shortcuts
      if (e.ctrlKey) {
        switch (key) {
          case "U": // View Source
          case "R": // Refresh
          case "P": // Print
          case "S": // Save
          case "N": // New Window
          case "T": // New Tab
          case "W": // Close Window
          case "F": // Find
            e.preventDefault();
            return;

          default:
            break;
        }

        // Zoom
        if (
          e.key === "+" ||
          e.key === "-" ||
          e.key === "=" ||
          e.key === "0"
        ) {
          e.preventDefault();
        }
      }

      // Refresh
      // if (e.key === "F5") {
      //   e.preventDefault();
      // }
    };

    // Disable drag & drop
    const preventDrag = (e) => {
      e.preventDefault();
    };

    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("keydown", handleKeyDown);

    window.addEventListener("dragover", preventDrag);
    window.addEventListener("drop", preventDrag);

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("keydown", handleKeyDown);

      window.removeEventListener("dragover", preventDrag);
      window.removeEventListener("drop", preventDrag);
    };
  }, []);
  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={true}
        newestOnTop
        closeOnClick
        pauseOnHover
        draggable
        theme="light"
      />

      <RouteComponent />
      <SessionExpiredModal />
    </>
  );
}

export default App;